import React, { useId } from 'react';
import './LoadingArtwork.css';

/** The same artwork and motion as the initial, pre-React loading screen. */
const LoadingArtwork = ({ skin = 'regular', period = 'day' }) => {
  const id = `loading-artwork-${useId().replace(/:/g, '')}`;
  const paint = (name) => `url(#${id}-${name})`;
  let artwork;

  switch (skin) {
    case 'orbital':
      artwork = (
        <>
          <defs>
            <radialGradient id={`${id}-planet`}>
              <stop stopColor="#d4ecf0" />
              <stop offset=".5" stopColor="#7fa6c9" />
              <stop offset="1" stopColor="#304769" />
            </radialGradient>
          </defs>
          <ellipse cx="120" cy="90" rx="106" ry="63" transform="rotate(-22 120 90)" stroke="#a9c5dd" strokeOpacity=".3" strokeDasharray="2 7" />
          <ellipse cx="120" cy="90" rx="84" ry="24" transform="rotate(-22 120 90)" stroke="#d5c398" strokeWidth="6" strokeOpacity=".8" />
          <circle cx="120" cy="90" r="43" fill={paint('planet')} />
          <path d="M44 123c19 18 94 2 146-38" stroke="#eddbb1" strokeWidth="5" strokeLinecap="round" />
          <circle cx="191" cy="40" r="2" fill="#eddbb1" />
          <circle cx="38" cy="57" r="1.5" fill="#bfdff4" />
        </>
      );
      break;
    case 'terminal':
      artwork = (
        <>
          <rect x="24" y="30" width="192" height="123" rx="7" fill="#fff" stroke="#c4c8cf" />
          <path d="M24 37a7 7 0 0 1 7-7h178a7 7 0 0 1 7 7v21H24Z" fill="#eef0f3" />
          <circle cx="39" cy="44" r="3" fill="#ff6059" />
          <circle cx="50" cy="44" r="3" fill="#ffbd2e" />
          <circle cx="61" cy="44" r="3" fill="#28ca42" />
          <text x="96" y="47" fontFamily="monospace" fontSize="8" fill="#626874">journal — zsh</text>
          <path d="m43 78 7 6-7 6M62 85h74M43 104h118M43 124h50" stroke="#4b5768" strokeWidth="2" strokeLinecap="round" />
          <rect x="99" y="118" width="6" height="10" fill="#4b5768" />
        </>
      );
      break;
    case 'atelier':
      artwork = (
        <>
          <path d="m64 24 122 12-12 127-122-12Z" fill="#e9dcc5" stroke="#d0b99a" />
          <path d="M52 30h128v126H52Z" fill="#fffaf0" stroke="#d0b99a" />
          <path d="M66 48h44M66 73h91M66 88h82M66 103h65M66 131h42" stroke="#a69073" strokeWidth="2" />
          <circle cx="167" cy="126" r="25" fill="#f0dcc4" stroke="#ad704b" strokeDasharray="2 3" />
          <circle cx="167" cy="126" r="17" stroke="#ad704b" />
          <path d="M154 130a13 13 0 0 1 26 0M155 133h24" stroke="#ad704b" strokeWidth="2" />
        </>
      );
      break;
    default:
      artwork = (
        <>
          <defs>
            <linearGradient id={`${id}-pearl`} x1="65" y1="45" x2="164" y2="160" gradientUnits="userSpaceOnUse">
              <stop stopColor="#fffefc" />
              <stop offset=".5" stopColor="#f8fbff" />
              <stop offset="1" stopColor="#d6e1f4" />
            </linearGradient>
            <linearGradient id={`${id}-sun`} x1="163" y1="35" x2="190" y2="96" gradientUnits="userSpaceOnUse">
              <stop stopColor="#fae1c0" />
              <stop offset="1" stopColor="#edb7b4" />
            </linearGradient>
          </defs>
          <circle cx="170" cy="65" r="31" fill={paint('sun')} />
          <path d="M43 139C14 134 20 97 47 94C38 61 91 44 111 77C142 45 179 68 178 94C217 88 231 139 197 151H65Z" fill="#d7dff0" opacity=".65" />
          <path d="M53 140C22 140 17 103 45 93C38 62 76 44 97 66C105 27 165 32 174 78C202 67 224 103 207 125C204 139 187 144 171 144Z" fill={paint('pearl')} stroke="#ffffff" strokeWidth="1.5" />
          <path d="M102 65C114 42 150 45 161 68M39 114C37 103 43 98 49 96" stroke="#fff" strokeWidth="3" strokeLinecap="round" opacity=".85" />
          <path d="m39 42 3-8 3 8 8 3-8 3-3 8-3-8-8-3 8-3Z" stroke="#c0cadf" />
          <circle cx="204" cy="54" r="2.5" fill="#dcb5c5" />
          <circle cx="29" cy="150" r="2" fill="#b4c5df" />
        </>
      );
  }

  return (
    <div className="loading-artwork" data-skin={skin} data-period={period} aria-hidden="true">
      <svg viewBox="0 0 240 180" fill="none" focusable="false">
        {artwork}
      </svg>
      <span className="loading-artwork__line" />
    </div>
  );
};

export default LoadingArtwork;
